module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "app-contanier"
  }, [_c('header-bar', {
    attrs: {
      "title": _vm.title
    },
    on: {
      "onLeftAction": _vm.onBackEvent
    }
  }), _vm._v(" "), _c('section', {
    staticClass: "content-panel"
  }, [_vm._m(0), _vm._v(" "), _c('section', [_c('div', {
    staticClass: "form-item vux-1px-b",
    on: {
      "click": _vm.onOpenAddress
    }
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "center"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cityNameStr),
      expression: "cityNameStr"
    }],
    staticClass: "form-input code-input",
    attrs: {
      "readonly": "",
      "id": "cityInput",
      "type": "text",
      "placeholder": "请选择所在城市"
    },
    domProps: {
      "value": (_vm.cityNameStr)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cityNameStr = $event.target.value
      }
    }
  })]), _vm._v(" "), _vm._m(2)]), _vm._v(" "), _c('div', {
    staticClass: "form-item vux-1px-b"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.companyName),
      expression: "companyName"
    }],
    staticClass: "form-input code-input",
    attrs: {
      "id": "nameInput",
      "type": "text",
      "maxlength": "50",
      "placeholder": "请输入公司名称"
    },
    domProps: {
      "value": (_vm.companyName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.companyName = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-item vux-1px-b",
    on: {
      "click": _vm.onClickCount
    }
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "center"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.countText),
      expression: "countText"
    }],
    staticClass: "form-input code-input",
    attrs: {
      "readonly": "",
      "id": "cityInput",
      "type": "text",
      "placeholder": "请选择公司常驻人数"
    },
    domProps: {
      "value": (_vm.countText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.countText = $event.target.value
      }
    }
  })]), _vm._v(" "), _vm._m(5)]), _vm._v(" "), _c('div', {
    staticClass: "form-item vux-1px-b"
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contactName),
      expression: "contactName"
    }],
    staticClass: "form-input code-input",
    attrs: {
      "id": "userNameInput",
      "type": "text",
      "maxlength": "50",
      "placeholder": "请输入联系人姓名"
    },
    domProps: {
      "value": (_vm.contactName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.contactName = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-item vux-1px-b"
  }, [_vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contactPhone),
      expression: "contactPhone"
    }],
    staticClass: "form-input code-input",
    attrs: {
      "id": "phoneInput",
      "maxlength": "11",
      "type": "tel",
      "placeholder": "请输入联系人手机号"
    },
    domProps: {
      "value": (_vm.contactPhone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.contactPhone = $event.target.value
      }
    }
  })])]), _vm._v(" "), _vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "form-item vux-1px-b"
  }, [_vm._m(9), _vm._v(" "), _c('div', {
    staticClass: "center"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.verificationCode),
      expression: "verificationCode"
    }],
    ref: "verCode",
    staticClass: "form-input code-input",
    attrs: {
      "id": "code",
      "type": "number",
      "placeholder": "请输入验证码"
    },
    domProps: {
      "value": (_vm.verificationCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.verificationCode = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "right-r"
  }, [(!_vm.isSendCode) ? _c('div', {
    staticClass: "plain-btn",
    attrs: {
      "for": "code"
    },
    on: {
      "click": _vm.fetchVerificationCode
    }
  }, [_vm._v("获取验证码")]) : _c('div', {
    staticClass: "plain-btn"
  }, [_vm._v(_vm._s(_vm.seconds) + "s后重试")])])])])]), _vm._v(" "), _c('popup', {
    staticClass: "vux-popup left-popup",
    attrs: {
      "position": 'bottom',
      "hideOnBlur": true
    },
    model: {
      value: (_vm.isShowAddreddPanel),
      callback: function($$v) {
        _vm.isShowAddreddPanel = $$v
      },
      expression: "isShowAddreddPanel"
    }
  }, [_c('address-select', {
    ref: "addressPanel",
    attrs: {
      "default-province": _vm.provinceId,
      "default-city": _vm.cityId,
      "level": 1
    },
    on: {
      "onCloseAddress": _vm.onCloseAddress
    }
  })], 1), _vm._v(" "), _c('popup', {
    staticClass: "vux-popup center-popup",
    attrs: {
      "position": 'bottom',
      "hideOnBlur": true
    },
    model: {
      value: (_vm.isShowCountPop),
      callback: function($$v) {
        _vm.isShowCountPop = $$v
      },
      expression: "isShowCountPop"
    }
  }, [_c('header', {
    staticClass: "popup-header coutn-popup-header vux-1px-b"
  }, [_c('div', {
    staticClass: "popup-btn cancel"
  }), _vm._v(" "), _c('div', {
    staticClass: "popup-title"
  }, [_vm._v("公司常驻人数")]), _vm._v(" "), _c('div', {
    staticClass: "popup-btn sure",
    on: {
      "click": _vm.onCloseCount
    }
  }, [_c('i', {
    staticClass: "close-icon icon iconfont"
  }, [_vm._v("")])])]), _vm._v(" "), _c('picker', {
    ref: "countPicker",
    attrs: {
      "title": '公司常驻人数',
      "popup-title": '公司常驻人数',
      "placeholder": '请选择公司常驻人数(50人以上)',
      "data": _vm.countList,
      "show-name": true
    },
    on: {
      "on-change": _vm.onChangeCount
    },
    model: {
      value: (_vm.peopleCount),
      callback: function($$v) {
        _vm.peopleCount = $$v
      },
      expression: "peopleCount"
    }
  })], 1), _vm._v(" "), _c('footer', {
    staticClass: "footer-panel"
  }, [_c('div', {
    staticClass: "primary-btn",
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("提交申请")])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "banner"
  }, [_c('img', {
    attrs: {
      "width": "100%",
      "src": require("../../assets/banner.png"),
      "title": "入驻成功¥200充值奖励"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "left"
  }, [_c('label', {
    staticClass: "form-label",
    attrs: {
      "autocomplete": "off",
      "for": "cityInput"
    }
  }, [_vm._v("所在城市")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "right-r"
  }, [_c('i', {
    staticClass: "arrow icon iconfont"
  }, [_vm._v("")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "left"
  }, [_c('label', {
    staticClass: "form-label",
    attrs: {
      "autocomplete": "off",
      "for": "nameInput"
    }
  }, [_vm._v("公司名称")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "left"
  }, [_c('label', {
    staticClass: "form-label",
    attrs: {
      "autocomplete": "off",
      "for": "cityInput"
    }
  }, [_vm._v("公司常驻人数")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "right-r"
  }, [_c('i', {
    staticClass: "arrow icon iconfont"
  }, [_vm._v("")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "left"
  }, [_c('label', {
    staticClass: "form-label",
    attrs: {
      "autocomplete": "off",
      "for": "userNameInput"
    }
  }, [_vm._v("联系人姓名")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "left"
  }, [_c('label', {
    staticClass: "form-label",
    attrs: {
      "autocomplete": "off",
      "for": "phoneInput"
    }
  }, [_vm._v("联系人手机号")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-item vux-1px-b des"
  }, [_c('span', {
    staticClass: "ps-des"
  }, [_vm._v("注：200元充值奖励将发放至此手机号账户")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "left"
  }, [_c('label', {
    staticClass: "form-label",
    attrs: {
      "autocomplete": "off",
      "for": "code"
    }
  }, [_vm._v("验证码")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5f57217c"}!./src/pages/Application/components/Submit/main.html
// module id = 1510
// module chunks = 7